<template>
  <div class="arrival page-component">
    <div class="container">
      <h1 class="text-center">{{ title }}</h1>
      <p class="lead-text text-center" v-if="lead">{{ $prismic.richTextAsPlain(lead) }}</p>
      <div class="arrival__map-wrapper">
        <div class="arrival__map-description">
          <prismic-rich-text class="arrival__description lead-text" :field="description" />
        </div>
        <div class="arrival__map-container">
          <img src="/images/arrival/switzerland.png" alt="Map of Switzerland" />
          <div class="arrival__item-container">
            <div class="arrival__item-svg-routes" id="svgContainerArrival">
              <!--<img src="/images/area/area-svg-routes.svg" />-->
              <simple-svg
                src="/images/arrival/arrival-svg-routes.svg"
                width="100%"
                height="100%"
              />
            </div>
            <div class="arrival__item arrival__item--basel state-hidden"><span>Basel</span></div>
            <div class="arrival__item arrival__item--konstanz state-hidden"><span>Konstanz</span></div>
            <div class="arrival__item arrival__item--bern state-hidden"><span>Bern</span></div>
            <div class="arrival__item arrival__item--kriens state-hidden"><span>Kriens</span></div>
            <div class="arrival__item arrival__item--zurich state-hidden"><span>Zürich</span></div>
            <div class="arrival__item arrival__item--genf state-hidden"><span>Genf</span></div>
            <div class="arrival__item arrival__item--lugano state-hidden"><span>Lugano</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../EventBus'

export default {
  name: 'Arrival',
  props: ['title', 'lead'],
  data () {
    return {
      description: null
    }
  },
  methods: {
    async getContent (language) {
      let document = 	await this.$prismic.client.getByUID('pagedescription', 'arrival', { lang : language })
      if (document) {
        this.description = document.data.text
      }
    }
  },
  async created () {
    await this.getContent(window.KriensTourismus.language)
    // Listen to Language Change
    EventBus.$on(EventBus.constants.LANGUAGE_CHANGED, (language) => this.getContent(language))
  },
}
</script>